export const customStyles = {
	control: (provided, state) => ({
		...provided,
		borderRadius: "6px",
		// width: "100%",
		borderColor: "rgba(84, 100, 99, 1)",
		boxShadow: state.isFocused ? "none" : provided.boxShadow,
		"&:hover": {
			borderColor: state.isFocused ? "rgba(84, 100, 99, 1)" : provided.borderColor,
		},
		height: "44px",
		minHeight: "44px",
		padding: "0",
	}),
	option: (provided) => ({
		...provided,
		textTransform: "capitalize",
		backgroundColor: "transparent",
		fontWeight: "500",
		fontSize: "14px",
		color: "rgba(94, 141, 190, 1)"
	}),
	indicatorSeparator: () => ({
		display: "none", // Hide the indicator separator
	}),
	singleValue: (provided, state) => ({
		...provided,
		color: "rgba(85, 85, 85, 1)",
		fontSize: "16px",
		fontWeight: "500",
	}),
	menu: (provided) => ({
		...provided,
		border: "2px solid #F5F5F7",
		background: " #FFF",
		boxShadow: "0px 4px 20px -10px rgba(0, 0, 0, 0.25)",
	}),

	multiValue: (provided) => ({
		...provided,
		background: "#EFF8FF",
	}),
	placeholder: (provided) => ({
		...provided,
		fontSize: "16px",
		color: "rgba(138, 138, 138, 1)"
	}),
	valueContainer: (provided) => ({
		...provided,
		padding: "0px 8px",
		height: "25px",
	}),

	indicatorsContainer: (provided) => ({
		...provided,
		display: "none",
	}),
	input: (provided) => ({
		...provided,
		padding: "0px",
		margin: "0px",
		height: "25px",
	}),
};

export const customStylesForNewRegistration = {
	control: (provided, state) => ({
		...provided,
		borderRadius: "8px",
		// width: "100%",
		borderColor: "rgba(84, 100, 99, 1)",
		boxShadow: state.isFocused ? "none" : provided.boxShadow,
		"&:hover": {
			borderColor: state.isFocused ? "rgba(84, 100, 99, 1)" : provided.borderColor,
		},
		height: "44px",
		minHeight: "44px",
		padding: "0",
	}),
	option: (provided) => ({
		...provided,
		textTransform: "capitalize",
		backgroundColor: "transparent",
		color: "black",
		fontSize: "14px",
	}),
	indicatorSeparator: () => ({
		display: "none", // Hide the indicator separator
		// height:"44px"// keep it same as the control height
	}),
	singleValue: (provided, state) => ({
		...provided,
		color: "#5B5B5B",
		fontSize: "16px",
		fontWeight: "500",
	}),
	menu: (provided) => ({
		...provided,
		border: "2px solid #F5F5F7",
		background: " #FFF",
		maxHeight: "180px",
		boxShadow: "0px 4px 20px -10px rgba(0, 0, 0, 0.25)",
		overflowY: "scroll",
	}),

	multiValue: (provided) => ({
		...provided,
		background: "#EFF8FF",
	}),
	placeholder: (provided) => ({
		...provided,
		fontSize: "16px",
	}),
	valueContainer: (provided) => ({
		...provided,
		padding: "0px 8px",
		height: "25px",
	}),

	indicatorsContainer: (provided) => ({
		...provided,
		padding: "1px",
		height: "44px",
	}),
	input: (provided) => ({
		...provided,
		padding: "0px",
		margin: "0px",
		height: "25px",
	}),
};